import RULES from './rules.json'

import type { Rule } from './schema'

export interface RulesPayload {
  rulesValidations: RulesObject
}

export type RuleNameType = keyof typeof RULES

export type RulesTypes = { [key in RuleNameType]: RuleNameType }

export type RulesObject = {
  [key in RuleNameType]: Rule
}

export enum ModalTypeUpgradePlan {
  STARTER = 'starter',
  ADVANCE = 'advance'
}
